export enum FirebaseEvents {
  schedule_complete = 'SCHEDULE_schedule_completed',
  schedule_abort = 'SCHEDULE_abort_schedule',
  schedule_selected_product = 'SCHEDULE_selected_product',
  schedule_selected_service = 'SCHEDULE_selected_service',
  schedule_cancelled = 'SCHEDULE_cancelled',
  schedule_unavailable_service = 'SCHEDULE_unavailable_service',
  schedule_selected_attendance_type = 'SCHEDULE_selected_attendance_type',
  schedule_specialist_search = 'SCHEDULE_specialist_search',
  schedule_selected_specialist = 'SCHEDULE_selected_specialist',
  schedule_selected_speciality = 'SCHEDULE_selected_speciality',
  schedule_open_lattes = 'SCHEDULE_open_lattes',
  schedule_open_specialist_contact = 'SCHEDULE_open_specialist_contact',
  schedule_specialist_schedule = 'SCHEDULE_specialist_schedule',
  schedule_selected_patient = 'SCHEDULE_selected_patient',
  schedule_selected_unit = 'SCHEDULE_selected_unit',
  schedule_empty_month = 'SCHEDULE_empty_month',
  schedule_calendar = 'SCHEDULE_calendar',
  schedule_age_restriction = 'SCHEDULE_age_restriction',
  schedule_redirect_call_center = 'SCHEDULE_redirect_call_center',
  schedule_redirect_support_whatsapp = 'SCHEDULE_redirect_support_whatsapp',
  schedule_health_insurance_restriction = 'SCHEDULE_health_insurance_restriction',
  schedule_copy_specialist_url = 'SCHEDULE_copy_specialist_url',
  schedule_specialist_filter = 'SCHEDULE_specialist_filter',
  schedule_payment_option = 'SCHEDULE_payment_option',
  schedule_modal_medical_record_error = 'schedule_modal_medical_record_error'
}
